import React, { createContext, useState, useContext, useEffect } from 'react';
import { userDashboardAPI } from '../../services/api';
import { useAuth } from './AuthContext';

const UserContext = createContext();

export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within UserProvider');
    }
    return context;
};

export const UserProvider = ({ children }) => {
    const [userStats, setUserStats] = useState({
        balance: 0,
        exposure: 0,
        availableBalance: 0,
        todayPL: { bets: 0, wins: 0, net: 0 }
    });
    const [loading, setLoading] = useState(true);
    const { user } = useAuth();

    const fetchUserStats = async () => {
        try {
            const response = await userDashboardAPI.getDashboardStats();
            setUserStats(response.data.data);
        } catch (error) {
            console.error('Error fetching user stats:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (user && user.role === 'user') {
            fetchUserStats();
            
            // Refresh stats every 30 seconds
            const interval = setInterval(fetchUserStats, 30000);
            return () => clearInterval(interval);
        }
    }, [user]);

    const value = {
        userStats,
        loading,
        refreshStats: fetchUserStats
    };

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    );
};